import styled from '@emotion/styled';
import Grid from '@react-css/grid';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Card from 'storybookConfig/stories/cells/Card';
import Menu from 'storybookConfig/stories/cells/Menu';
import { useAppSelector } from 'store/index';
import { selectIsSeller } from 'store/selectors/me/company';
import { selectIsSuperUser } from 'store/selectors/me/user';

const MenuWrapper = styled(Card)`
  padding: 24px;
  position: sticky;
  top: 24px;
`;
enum SectionSegments {
  Brand = 'brand',
  SocialLinks = 'social',
  Attributes = 'attributes',
  Assets = 'assets',
  Shipping = 'shipping',
  ServiceOptions = 'service-options',
}

const MarketplaceTab = () => {
  const { pathname } = useLocation();
  const section = pathname.split('/')[3] as SectionSegments | undefined;
  const isSeller = useAppSelector(selectIsSeller);
  const isSuperUser = useAppSelector(selectIsSuperUser);

  // Redirect if not a seller or super user
  if (!isSeller || !isSuperUser) {
    return <Navigate to="/settings/preferences/account" replace />;
  }

  const selectedSection =
    section && Object.values(SectionSegments).includes(section) ? section : SectionSegments.Brand;

  return (
    <Grid columns="240px 1fr" gap="24px">
      <Grid.Item>
        <MenuWrapper>
          <Menu>
            <Menu.Link
              $iconName="info"
              $isActive={selectedSection === SectionSegments.Brand}
              to="/settings/marketplace/brand"
            >
              Brand
            </Menu.Link>
            <Menu.Link
              $iconName="language"
              $isActive={selectedSection === SectionSegments.SocialLinks}
              to="/settings/marketplace/social"
            >
              Social Links
            </Menu.Link>
            <Menu.Link
              $iconName="category"
              $isActive={selectedSection === SectionSegments.Attributes}
              to="/settings/marketplace/attributes"
            >
              Attributes
            </Menu.Link>
            <Menu.Link
              $iconName="imagesmode"
              $isActive={selectedSection === SectionSegments.Assets}
              to="/settings/marketplace/assets"
            >
              Assets
            </Menu.Link>
            <Menu.Link
              $iconName="local_shipping"
              $isActive={selectedSection === SectionSegments.Shipping}
              to="/settings/marketplace/shipping"
            >
              Shipping
            </Menu.Link>
            <Menu.Link
              $iconName="settings"
              $isActive={selectedSection === SectionSegments.ServiceOptions}
              to="/settings/marketplace/service-options"
            >
              Service Options
            </Menu.Link>
          </Menu>
        </MenuWrapper>
      </Grid.Item>
      <Card>
        <Outlet />
      </Card>
    </Grid>
  );
};

export default MarketplaceTab;
